import { Button, Divider, Flex } from '@cmpsr/components';

type FooterProps = {
  onSaveActionPlan: () => void;
};

export const Footer = ({ onSaveActionPlan }: FooterProps) => {
  return (
    <Flex
      position="fixed"
      direction="column"
      bottom="0"
      width="full"
      alignItems="center"
      backgroundColor="background-page"
    >
      <Divider />
      <Button
        variant="accent"
        size={{ base: 'm', md: 'l' }}
        width={{ base: '335px', md: '355px' }}
        mx={{ base: 'spacer-5', md: 'auto' }}
        mt="spacer-4"
        mb="spacer-6"
        onClick={onSaveActionPlan}
      >
        Save Action Plan
      </Button>
    </Flex>
  );
};

export default Footer;
